import Image from 'next/image';
import ImgixLoader from '@utils/images/ImgixLoader';
import { Link } from "@components/core";
import ProductDiscountSticker from "@components/views/Product/Shared/ProductDiscountSticker";

function CartImageLink({ product }) {
  return (
    <Link
      passHref
      href={`/products/${product.slug}?context=sales`}
    >
      <div
        className="sales-cart-image-container"
      >
        <Image
          loader={ImgixLoader}
          src={product.main_picture_url || ""}
          alt={product.name}
          fill
          sizes="128px"
        />

        <ProductDiscountSticker product={product} context="sales" className="bottomed" />
      </div>
    </Link>
  );
}

export default CartImageLink;
